import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function BalanceSheetReport() {
  return <ReportForm reportAPI={ ReportAPI.BALANCE_SHEET } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/BalanceSheetReport.js